import { notification } from '../components/Notifications'
import { formatSlotTaskToast } from './formatSlotTaskToast'
import type { SlotTaskTerminalResult } from '../hooks/useSlotBackgroundTask'

// Shared terminal-toast handler for useSlotBackgroundTask callers that don't go through
// SlotTaskContext (which has its own inline copy of this same formatting/toast call).
export const notifySlotTaskTerminal = (result: SlotTaskTerminalResult): void => {
  const toast = formatSlotTaskToast(result)
  notification(toast.title, {
    variant: toast.variant,
    subTitle: toast.subTitle,
    persist: toast.variant !== 'success'
  })
}
